import React from 'react';
import { Alert } from 'antd';
import NameField from '../../components/NameField';
import DescriptionField from '../../components/DescriptionField';
import AvailableToClientField from '../../components/AvailableToClient';
import PeriodField from '../../components/PeriodFields';
import UploadField from '../../components/UploadField';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import SelectType from '../../components/SelectType';
import styles from '../../index.module.scss';

const FormComponent = ({ submitStateMessage }) => {
  const hasRecord = useModalWatch({
    name: modalNames.attachmentsForm,
    selector: (state) => Boolean(state?.props?.record),
  });

  return (
    <>
      {Boolean(submitStateMessage) && (
        <Alert message={submitStateMessage} type="error" />
      )}
      <div className={styles.nameDescriptionWrapper}>
        <NameField />
        <DescriptionField />
        <AvailableToClientField />
      </div>
      <PeriodField />
      {hasRecord && <SelectType />}
      <UploadField label="Вложение" multiple={true} />
    </>
  );
};

export default FormComponent;
